import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  overflow: hidden;
  text-align: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.backgroundColor};

  * > img {
    width: 60px;
    height: 60px;
  }

  > h2 {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    max-width: 220px;
    color: ${({ theme }) => theme.foregroundColor};
  }

  > span {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.foregroundColor};

    > button {
      padding: 0;
      background: none;
      border: none;
      color: #4759f5;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;
